import { Home } from "@mui/icons-material";
import { Button, Card, Container, Grid, Link, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import * as ROUTES from "../constants/Routes";

const Policy = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Container>
      <Button
        style={{ position: "absolute", top: 24, left: 64 }}
        startIcon={<Home />}
        onClick={() => {
          navigate(ROUTES.LANDING_PAGE);
        }}
      >
        {t("home")}
      </Button>
      <Grid container alignItems={"center"} justifyContent={"center"} style={{ minHeight: "100vh", paddingTop: 74 }}>
        <Grid item xs={12} md={10} lg={9}>
          <Card style={{ padding: 26, borderRadius: 16, marginTop: 64, paddingTop: 32, marginBottom: 68 }}>
            <Grid item xs={12}>
              <Typography variant="h4" style={{ marginBottom: 16 }}>
                {t("privacyPolicy")}
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                Osatu S. Coop. se compromete a proteger la privacidad de sus usuarios. Esta declaración de privacidad no aplica ni a la
                página corporativa
                <a href="https://www.bexencardio.com"> www.bexencardio.com</a>, ni a ningún otro subdominio de bexencardio.com, ni aplica a
                Osatu S. Coop. en el contexto de sus actividades corporativas. Esta política de privacidad únicamente aplica a la app
                Reanibex Alert. Para más información sobre la política de esas páginas, puede acceder al sitio web que las contenga.
              </Typography>
              <Typography variant="h6" style={{ marginTop: 12 }}>
                ¿Qué información se recoge de los usuarios?
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                Los usuarios no registrados no tienen acceso al área privada de la app Reanibex Alert y por tanto no se recogen datos de
                ningún tipo. En el caso de los usuarios registrados los datos que se recogen incluyen: email para la cuenta de usuarios,
                localización, e identificador de notificaciones para el móvil.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                Esta app en ningún caso recolecta información de pacientes, ni datos biométricos y/o de salud de sus usuarios. Limitándose a
                ser un sistema de aviso para ayudar a mejorar los tiempos de respuesta en eventos cardiacos que se puedan producir fuera del
                ámbito hospitalario.
              </Typography>
              <Typography variant="h6" style={{ marginTop: 12 }}>
                ¿Porqué me pide acceder a mi ubicación en segundo plano?
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                La principal tarea de Reanibex Alert es la de avisar a los usuarios más cercanos de la posible parada cardiorrespiratoria de
                una persona para que los usuarios más cercanos acudan a ayudarle.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                Por tanto, Reanibex Alert accede a la ubicación del usuario en segundo plano para poder avisarle de una parada
                cardiorrespiratoria cuando es el usuario que más cerca esté de la persona que necesita ayuda.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                Para que los usuarios puedan ir a ayudar en una parada cardiorrespiratoria es necesario que reciban un aviso,
                independientemente de si están usando o no la aplicación en ese momento. Este aviso sólo se puede dar si la aplicación sabe
                que el usuario está cerca de la parada cardiorrespiratoria.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                La aplicación Reanibex Alert accede a la ubicación en segundo plano únicamente en el momento en el que se produce el aviso –
                se manda una notificación al móvil que inicia el acceso a la ubicación - , y en ningún momento accederá a la ubicación en
                segundo plano si no se ha producido un evento cardiorrespiratorio
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                Los datos de ubicación únicamente se utilizan para calcular la cercanía del usuario a una parada cardiorrespiratoria en el
                momento en el que se está produciendo. Estos datos no son almacenados ni usados para ningún otro fin o procesamiento.
              </Typography>
              <Typography variant="h6" style={{ marginTop: 12 }}>
                ¿Para qué se usa la información recolectada?
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                La app Reanibex Alert es usada por usuarios con formación en cardioprotección para ayudar durante eventos cardiológicos.
                Cuando hay un evento, los usuarios activos más cercanos a un evento son avisados para que acudan a la zona a ayudar en las
                labores de asistencia.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                Debido a las características de la app, y para poder dar el servicio descrito es necesario recoger los datos indicados en el
                apartado anterior. En concreto se recogen:
              </Typography>
              <ul>
                <li>
                  Email: a modo de identificador de cuenta de usuario y que sólo personas con la formación adecuada puedan acceder a ella.
                </li>

                <li>
                  Localización: para poder mejorar los tiempos de respuesta a un evento – crítico en el ámbito de la cardioprotección – es
                  necesario conocer qué usuarios están más cerca del evento, aunque no tenga la app en primer plano, y así avisar a los que
                  estén más cerca y/o dentro del rango de actuación.
                </li>
                <li>
                  Identificador de móvil para notificaciones: con el fin de mandar notificaciones/avisos a los usuarios es necesario
                  distinguir entre los diferentes móviles que tienen acceso a la aplicación, ya que se enviarán notificaciones a aquellos
                  usuario que estén más cerca de un evento.
                </li>
              </ul>

              <Typography variant="h6" style={{ marginTop: 12 }}>
                ¿Con quién se comparte la información?
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                Osatu S. Coop. usa proveedores de servicios Cloud - Google Inc. - para poder llevar a cabo las tareas de funcionamiento
                básico de la app:
              </Typography>
              <ul>
                <li>Gestión de usuarios</li>
                <li>Gestión de flota de desfibriladores</li>
                <li>Gestión de notificaciones y calculo de cercanía al evento</li>
              </ul>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                En cualquier caso, no se comparten directamente datos de usuarios con los proveedores de servicios contratados, sino que se
                usan sus servicios para el procesado y almacenamiento de datos, pero el procesado y almacenamiento siempre lo realiza Osatu
                S. Coop. y así poder llevar a cabo el servicio contratados/solicitados
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                En todos los casos los servicios que procesan los datos y el almacenamiento de estos - necesarios para llevar las tareas de
                funcionamiento de la app - se encuentran ubicados dentro de la UE, y ningún dato es transmitido a países de terceros
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                Por tanto, Osatu S. Coop. no comparte información con terceros fuera de los proveedores – los indicados al inicio de esta
                sección – de servicio subcontratadas que le permiten dar el servicio definido en la descripción del producto en la Play
                Store de Google.
              </Typography>
              <Typography variant="h6" style={{ marginTop: 12 }}>
                ¿Qué derechos tiene como usuario?
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                Los usuarios registrados tienen derecho al acceso, modificación y olvido de los datos personales, pero no para los datos de
                otros usuarios.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                Puesto que dicha cuenta está ligada a una plataforma de formación, el usuario dispondrá de las herramientas necesarias para
                eliminar y modificar los datos de usuario en ella – y cuyo acceso precede al posible uso de la app - . Si el usuario
                requiere acceso a más datos de los que se muestran en su cuenta dentro de la plataforma, este podrá enviar un email a{" "}
                <Link>info@bexencardio.com</Link> para poder acceder a ellos.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h4" style={{ marginTop: 12 }}>
                Política de Cookies
              </Typography>
              <Typography variant="h6" style={{ marginTop: 12 }}>
                ¿Qué es una Cookie?
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                Una cookie es un fichero inofensivo que se almacena en navegadores web y algunas app, y que se almacena en ellos cada vez
                que se accede a un sitio web. Por ejemplo, para mantener una sesión de usuario o para guardar preferencias de un sitio. En
                algunos casos también se llegan a utilizar para fines publicitarios.
              </Typography>
              <Typography variant="h6" style={{ marginTop: 12 }}>
                ¿Qué tipo de Cookies se usan?
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                La app Reanibex Alert no usa datos de cookies, aunque usa herramientas similares – tokens – cuya única finalidad es la de
                mantener la sesión de usuario activa durante el uso de la aplicación.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                La app Reanibex Alert no usa cookies de ningún otro tipo, y no utiliza cookies con fines estadísticos, publicitarios,
                creación de perfiles, ni de marketing.
              </Typography>
              <Typography variant="h6" style={{ marginTop: 12 }}>
                ¿Qué ocurre si bloqueo las Cookies?
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                Puesto que esta aplicación no usa cookies, es posible seguir utilizando la app sin problemas. Si bien, en algunos
                navegadores es posible que no pueda iniciar sesión o tenga dificultades manteniendo la sesión abierta. Existen opciones en
                los diferentes navegadores que le permite filtrar el tipo de cookies a bloquear.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h4" style={{ marginTop: 12 }}>
                Aviso Legal
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                De acuerdo a lo establecido en el artículo 10 de la Ley Española 34/2002, del 11 de julio, sobre los servicios de (LSSICE),
                los datos identificativos de la empresa se muestras más abajo.
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                Osatu S.Coop, Edificio Zearrekobuelta, Subida de Areitio, 5, 48260 Ermua (Vizcaya) - España
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>
                Telefon: +34 943 170 220 ó +34 943 170 266 / Fax. +34 943 170 227
              </Typography>
              <Typography style={{ textAlign: "justify", marginTop: 9 }}>E-mail: info@bexencardio.com</Typography>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Policy;
